
import actions from "./actions"
import mutations from "./mutations"

export default  {
    namespaced: true,

    state: () => ({ 
        layout: 'app',
        isShowAddOrUpdateModal: false,
        myPointsOverview: { weeklyRemainingPoints: 0, walletPoints: 0 },
        leaderBoardPointsList: [],
        allTimeleaderBoardPointsList: [],
        categoriesList:[],
        employeeList:[],
        pointsList: [],
        selectedEmployees: [],
        tableColumns: ['category', 'sub_category','given_by', 'points','date', 'action'],
     }),

    mutations: mutations,
    actions: actions,
    getters: { 
        isShowModal(state) {
            return state.isShowAddOrUpdateModal;
        },
     }
  }
